import { NcaLink } from 'nca-acquiring-theme';
import * as React from 'react';
export default {
  NcaLink,
  React
};